import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './hooks/useAuth';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import PendingApprovalPage from './pages/PendingApprovalPage';
import DashboardPage from './pages/DashboardPage';
import PacientesPage from './pages/PacientesPage';
import PesquisasPage from './pages/PesquisasPage';
import UsuariosPage from './pages/UsuariosPage';
import PatientViewPage from './pages/PatientViewPage';
import ConfigPesquisaPage from './pages/ConfigPesquisaPage';
import CalendarioPage from './pages/CalendarioPage';
import ExportacaoPage from './pages/ExportacaoPage';
import EstatisticasPage from './pages/EstatisticasPage';
import InstrucoesPage from './pages/InstrucoesPage';
import AuditLogPage from './pages/AuditLogPage';

const spinner = (
  <div className="loading-full">
    <div className="spinner" style={{ borderTopColor: 'var(--blue)', borderColor: 'var(--border)' }} />
  </div>
);

function PrivateRoute({ children, adminOnly = false, superAdminOnly = false }) {
  const { profile } = useAuth();
  if (superAdminOnly && profile?.role !== 'super_admin') return <Navigate to="/" replace />;
  if (adminOnly && !['super_admin', 'admin_pesquisa'].includes(profile?.role)) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Layout />}>
        <Route index element={<DashboardPage />} />
        <Route path="pacientes" element={<PacientesPage />} />
        <Route path="pesquisas" element={<PesquisasPage />} />
        <Route path="paciente" element={<PatientViewPage />} />
        <Route path="config-pesquisa" element={<PrivateRoute adminOnly><ConfigPesquisaPage /></PrivateRoute>} />
        <Route path="calendario" element={<CalendarioPage />} />
        <Route path="instrucoes" element={<InstrucoesPage />} />
        <Route path="exportacao" element={<ExportacaoPage />} />
        <Route path="estatisticas" element={<EstatisticasPage />} />
        <Route path="usuarios" element={<PrivateRoute adminOnly><UsuariosPage /></PrivateRoute>} />
        <Route path="audit" element={<PrivateRoute superAdminOnly><AuditLogPage /></PrivateRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function AuthGate() {
  const { authStage } = useAuth();

  if (authStage === 'loading')           return spinner;
  if (authStage === 'unauthenticated')   return <LoginPage />;
  if (authStage === 'pending_approval')  return <PendingApprovalPage />;
  return <AppRoutes />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AuthGate />
      </AuthProvider>
    </BrowserRouter>
  );
}
